import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { alertSuccess, alertServerError, alertError } from "../../../helpers/alertError";
import PageLayout from "../../../layouts/PageLayout";
import PageContainer from "../../../components/ui/PageContainer";
import { productService, uploadService } from "@cabukaka/services";
import ProductForm from "../../../components/features/products/ProductForm";
import { ProductFormData } from "../../../types/Product";
import { useToken } from "../../../hooks/auth/useToken";

export default function NewProductPage() {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const { token } = useToken();

    const handleSubmit = async (formData: ProductFormData) => {
        setIsLoading(true);
        if (!token) {
            alertError("Une erreur s'est produite");
            setIsLoading(false);
            return;
        }

        try {
            // Upload de l'image
            let imageUrl = '';
            if (formData.image && formData.image.size > 0) {
                const uploaded = await uploadService.uploadMultiple([formData.image], token);
                imageUrl = uploaded[0] || '';
            }

            // Données pour l'API
            const submitData = {
                name: formData.name,
                description: formData.description,
                price: formData.price,
                type: formData.type,
                lengths: formData.lengths,
                defaultLength: formData.defaultLength,
                quality: formData.quality,
                density: formData.density,
                texture: formData.texture,
                badge: formData.badge || '',
                imageUrl: imageUrl,
                inStock: true
            };

            await productService.baseService.create(submitData, token);
            alertSuccess("Produit créé avec succès");
            navigate(-1);
        } catch (error: any) {
            console.error(error);
            alertServerError(error);
        } finally {
            setIsLoading(false);
        }
    };
    

    return (
        <PageLayout title="Nouveau produit">
            <PageContainer>
                <ProductForm
                    onSubmit={handleSubmit}
                    isSubmitting={isLoading}
                />
            </PageContainer>
        </PageLayout>
    );
}